/**
 * Avertissements sur les données de consommation extrapolées (bilan de la courbe renvoyé par le serveur) : un message
 * fort par période recopiée (trou de plus de 4 semaines), sinon un message discret au-delà de 20 % de points
 * extrapolés — un seul type d'avertissement (06/10/2026). Utilisés en Step 3, en tête du rapport et dans le PDF.
 */
export interface MessageExtrapolation { fort: boolean; texte: string }

function dateFr(iso: string): string {
  if (!iso) return ''
  const p = String(iso).substring(0, 10).split('-')
  return p[2] + '/' + p[1] + '/' + p[0]
}

function pourcent(v: number): string {
  return (Math.round((v || 0) * 10) / 10).toLocaleString('fr-FR', { maximumFractionDigits: 1 })
}

export function messagesExtrapolation(stats: any): MessageExtrapolation[] {
  const warnings = (stats && stats.warnings) || []
  const recopies = warnings.filter((w: any) => w.code === 'RECOPIE_PROFIL_CLIENT')
  if (recopies.length) {
    return recopies.map((w: any) => ({
      fort: true,
      texte: 'Données extrapolées du ' + dateFr(w.start) + ' au ' + dateFr(w.end) + ' : pas de mesures sur cette période. '
        + 'Le profil du client a été recopié (mêmes jours et heures des semaines voisines). Les résultats sur cette période sont estimés.',
    }))
  }
  if (warnings.some((w: any) => w.code === 'POINTS_CALCULES_SUP_20')) {
    return [{ fort: false, texte: 'Plus de 20 % de la courbe a été extrapolée (' + pourcent(stats.calculatedPointsPercent)
      + ' %) : vérifiez que le fichier couvre bien une année.' }]
  }
  return []
}
